// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import EditOutlined from '@ant-design/icons/EditOutlined';
import LogoutOutlined from '@ant-design/icons/LogoutOutlined';
import SignatureOutlined from '@ant-design/icons/SignatureOutlined';

interface Props {
  handleLogout: () => void;
  handleEditProfile: () => void;
  handleMySignatures?: () => void;
  showSignatures?: boolean;
}

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

export default function ProfileTab({ handleLogout, handleEditProfile, handleMySignatures, showSignatures }: Props) {
  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 24 } }}>
      <ListItemButton onClick={handleEditProfile}>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary="My Profile" />
      </ListItemButton>
       {showSignatures && ( 
      <ListItemButton onClick={handleMySignatures}>
        <ListItemIcon>
          <SignatureOutlined />
        </ListItemIcon>
        <ListItemText primary="My Signatures" />
      </ListItemButton>
      )} 
      <ListItemButton onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Logout" />
      </ListItemButton>
    </List>
  );
}

